module.exports = __webpack_public_path__ + "static/media/Bomber.14bddf17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapDecoration/Bomber.png
// module id = 865
// module chunks = 0